export default class ErrorHandling {

    static triggerError(message: string, e: Error) {
        const event = new CustomEvent("errorMessage", { detail: { message: message } } as any);
        document.dispatchEvent(event);
        console.error("Message", message, e);
    }

}